const lodash = require('lodash');
const { createReducer } = require('../../helpers');
const {
  GET_PRODUCTS_LIST_WITH_FILTERS,
  GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS,
  GET_PRODUCTS_LIST_WITH_FILTERS_ERROR,
  GET_PRODUCTS_LIST_WITH_FILTERS_RESET,

  GET_PRODUCTS_LIST_WITHOUT_FILTERS,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET,

  GET_PRODUCTS_LIST_WITH_SEARCH,
  GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS,
  GET_PRODUCTS_LIST_WITH_SEARCH_ERROR,
  GET_PRODUCTS_LIST_WITH_SEARCH_RESET,

  GET_NEW_PRODUCT,
  GET_NEW_PRODUCT_SUCCESS,
  GET_NEW_PRODUCT_ERROR,
  GET_NEW_PRODUCT_RESET,

  GET_FEATURED_PRODUCT,
  GET_FEATURED_PRODUCT_SUCCESS,
  GET_FEATURED_PRODUCT_ERROR,
  GET_FEATURED_PRODUCT_RESET,

  GET_PARTICULAR_PRODUCTS,
  GET_PARTICULAR_PRODUCTS_SUCCESS,
  GET_PARTICULAR_PRODUCTS_ERROR,
  GET_PARTICULAR_PRODUCTS_RESET,

  GET_STORE_DETAILS,
  GET_STORE_DETAILS_SUCCESS,
  GET_STORE_DETAILS_ERROR,
  GET_STORE_DETAILS_RESET,

  GET_STORE_PRODUCT_LIST,
  GET_STORE_PRODUCT_LIST_SUCCESS,
  GET_STORE_PRODUCT_LIST_ERROR,
  GET_STORE_PRODUCT_LIST_RESET,

  GET_STORE_FEATURED_PRODUCT_LIST,
  GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS,
  GET_STORE_FEATURED_PRODUCT_LIST_ERROR,
  GET_STORE_FEATURED_PRODUCT_LIST_RESET,

  GET_PRODUCT_CATEGORY,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_CATEGORY_ERROR,
  GET_PRODUCT_CATEGORY_RESET,
} = require('./constants');

const initialState = {
  productWithFilters: {
    data: {},
    loading: false,
    error: false,
  },
  productWithoutFilters: {
    data: {},
    loading: false,
    error: false,
  },
  productWithSearch: {
    data: {},
    loading: false,
    error: false,
  },
  productCategory: {
    data: {},
    loading: false,
    error: false,
  },
  newProducts: {
    data: {},
    loading: false,
    error: false,
  },
  featuredProducts: {
    data: {},
    loading: false,
    error: false,
  },
  particularProducts: {
    data: {},
    loading: false,
    error: false,
  },
  storeDetails: {
    data: {},
    loading: false,
    error: false,
  },
  storeProductList: {
    data: {},
    loading: false,
    error: false,
  },
  storeFeaturedProductList: {
    data: {},
    loading: false,
    error: false,
  },
};

module.exports = createReducer(
  {
    //
    [GET_PRODUCT_CATEGORY]: (draft) => ({
      productCategory: {
        ...draft.productCategory,
        loading: true,
        error: false,
      },
    }),
    [GET_PRODUCT_CATEGORY_SUCCESS]: (draft, action) => ({
      productCategory: {
        ...draft.productCategory,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_PRODUCT_CATEGORY_ERROR]: (draft, action) => ({
      productCategory: {
        ...draft.productCategory,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_PRODUCT_CATEGORY_RESET]: () => ({
      productCategory: { ...initialState.productCategory },
    }),

    //
    [GET_PRODUCTS_LIST_WITH_FILTERS]: (draft) => ({
      productWithFilters: {
        ...draft.productWithFilters,
        loading: true,
        error: false,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_FILTERS_SUCCESS]: (draft, action) => ({
      productWithFilters: {
        ...draft.productWithFilters,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_FILTERS_ERROR]: (draft, action) => ({
      productWithFilters: {
        ...draft.productWithFilters,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_FILTERS_RESET]: () => ({
      productWithFilters: { ...initialState.productWithFilters },
    }),

    [GET_PRODUCTS_LIST_WITHOUT_FILTERS]: (draft) => ({
      productWithoutFilters: {
        ...draft.productWithoutFilters,
        loading: true,
        error: false,
      },
    }),
    [GET_PRODUCTS_LIST_WITHOUT_FILTERS_SUCCESS]: (draft, action) => ({
      productWithoutFilters: {
        ...draft.productWithoutFilters,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_PRODUCTS_LIST_WITHOUT_FILTERS_ERROR]: (draft, action) => ({
      productWithoutFilters: {
        ...draft.productWithoutFilters,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_PRODUCTS_LIST_WITHOUT_FILTERS_RESET]: () => ({
      productWithoutFilters: { ...initialState.productWithoutFilters },
    }),

    [GET_PRODUCTS_LIST_WITH_SEARCH]: (draft) => ({
      productWithSearch: {
        ...draft.productWithSearch,
        loading: true,
        error: false,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_SEARCH_SUCCESS]: (draft, action) => ({
      productWithSearch: {
        ...draft.productWithSearch,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_SEARCH_ERROR]: (draft, action) => ({
      productWithSearch: {
        ...draft.productWithSearch,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_PRODUCTS_LIST_WITH_SEARCH_RESET]: () => ({
      productWithSearch: { ...initialState.productWithSearch },
    }),

    [GET_NEW_PRODUCT]: (draft) => ({
      newProducts: {
        ...draft.newProducts,
        loading: true,
        error: false,
      },
    }),
    [GET_NEW_PRODUCT_SUCCESS]: (draft, action) => ({
      newProducts: {
        ...draft.newProducts,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_NEW_PRODUCT_ERROR]: (draft, action) => ({
      newProducts: {
        ...draft.newProducts,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_NEW_PRODUCT_RESET]: () => ({
      newProducts: { ...initialState.newProducts },
    }),

    [GET_FEATURED_PRODUCT]: (draft) => ({
      featuredProducts: {
        ...draft.featuredProducts,
        loading: true,
        error: false,
      },
    }),
    [GET_FEATURED_PRODUCT_SUCCESS]: (draft, action) => ({
      featuredProducts: {
        ...draft.featuredProducts,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_FEATURED_PRODUCT_ERROR]: (draft, action) => ({
      featuredProducts: {
        ...draft.featuredProducts,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_FEATURED_PRODUCT_RESET]: () => ({
      featuredProducts: { ...initialState.featuredProducts },
    }),

    [GET_PARTICULAR_PRODUCTS]: (draft) => ({
      particularProducts: {
        ...draft.particularProducts,
        loading: true,
        error: false,
      },
    }),
    [GET_PARTICULAR_PRODUCTS_SUCCESS]: (draft, action) => ({
      particularProducts: {
        ...draft.particularProducts,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_PARTICULAR_PRODUCTS_ERROR]: (draft, action) => ({
      particularProducts: {
        ...draft.particularProducts,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_PARTICULAR_PRODUCTS_RESET]: () => ({
      particularProducts: { ...initialState.particularProducts },
    }),

    [GET_STORE_DETAILS]: (draft) => ({
      storeDetails: {
        ...draft.storeDetails,
        loading: true,
        error: false,
      },
    }),
    [GET_STORE_DETAILS_SUCCESS]: (draft, action) => ({
      storeDetails: {
        ...draft.storeDetails,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_STORE_DETAILS_ERROR]: (draft, action) => ({
      storeDetails: {
        ...draft.storeDetails,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_STORE_DETAILS_RESET]: () => ({
      storeDetails: { ...initialState.storeDetails },
    }),

    [GET_STORE_PRODUCT_LIST]: (draft) => ({
      storeProductList: {
        ...draft.storeProductList,
        loading: true,
        error: false,
      },
    }),
    [GET_STORE_PRODUCT_LIST_SUCCESS]: (draft, action) => ({
      storeProductList: {
        ...draft.storeProductList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_STORE_PRODUCT_LIST_ERROR]: (draft, action) => ({
      storeProductList: {
        ...draft.storeProductList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_STORE_PRODUCT_LIST_RESET]: () => ({
      storeProductList: { ...initialState.storeProductList },
    }),

    [GET_STORE_FEATURED_PRODUCT_LIST]: (draft) => ({
      storeFeaturedProductList: {
        ...draft.storeFeaturedProductList,
        loading: true,
        error: false,
      },
    }),
    [GET_STORE_FEATURED_PRODUCT_LIST_SUCCESS]: (draft, action) => ({
      storeFeaturedProductList: {
        ...draft.storeFeaturedProductList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_STORE_FEATURED_PRODUCT_LIST_ERROR]: (draft, action) => ({
      storeFeaturedProductList: {
        ...draft.storeFeaturedProductList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_STORE_FEATURED_PRODUCT_LIST_RESET]: () => ({
      storeFeaturedProductList: { ...initialState.storeFeaturedProductList },
    }),
  },
  initialState
);
